export const columnToColumnIcon = 'column-to-column';

enum LogicalOperationsEnum {
  IsIn = 'IsIn',
  IsNotIn = 'IsNotIn',
  Contains = 'Contains',
  NotContains = 'NotContains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
}

enum EmptyLogicalOperationsEnum {
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
}

enum IntegerOperationsEnum {
  GreaterThan = 'GreaterThanEq',
  LowerThan = 'LessThanEq'
}

export type LogicalOperations = LogicalOperationsEnum | EmptyLogicalOperationsEnum;
export const LogicalOperations = { ...LogicalOperationsEnum, ...EmptyLogicalOperationsEnum };

export type LogicalWithIntegerOperations = LogicalOperations | IntegerOperationsEnum;
export const LogicalWithIntegerOperations = { ...LogicalOperations, ...IntegerOperationsEnum };

enum DatesLogicalOperationsEnum {
  EarlierThanEq = 'EarlierThanEq',
  LaterThanEq = 'LaterThanEq',
  LastXDays = 'LastXDays',
  InLastXDays = 'InLastXDays'
}

export type DatesLogicalOperations = DatesLogicalOperationsEnum | EmptyLogicalOperationsEnum;
export const DatesLogicalOperations = { ...DatesLogicalOperationsEnum, ...EmptyLogicalOperationsEnum };

export enum LogicalColumnToColumnOperatorsEnum {
  EqualsColumn = 'EqualsColumn',
  NotEqualsColumn = 'NotEqualsColumn',
  ContainedInColumn = 'ContainedInColumn',
  NotContainedInColumn = 'NotContainedInColumn'
}

export enum IntegerColumnToColumnOperatorsEnum {
  GreaterThanColumn = 'GreaterThanColumn',
  LessThanColumn = 'LessThanColumn',
}

export enum DatesLogicalColumnToColumnOperatorsEnum {
  DayDifferenceGreaterThan = 'DayDifferenceGreaterThan',
  DayDifferenceLessThan = 'DayDifferenceLessThan',
}

export const logicalColumnToColumnOperators = Object.values(LogicalColumnToColumnOperatorsEnum).map((id) => ({ id, iconNextToValue: columnToColumnIcon }));
export const integerColumnToColumnOperators = Object.values(IntegerColumnToColumnOperatorsEnum).map((id) => ({ id, iconNextToValue: columnToColumnIcon }));
export const datesLogicalColumnToColumnOperators = Object.values(DatesLogicalColumnToColumnOperatorsEnum).map((id) => ({ id, iconNextToValue: columnToColumnIcon }));

export const ORIGINAL_ROW_ID = 'original_row_id';
export const EMAIL_LABEL_COLUMN_NAME = 'email';
export const FULL_NAME_LABEL_COLUMN_NAME = 'fullname';
export const JOB_TITLE_LABEL_COLUMN_NAME = 'jobtitle';
